import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import { getAccountCurrencyCode, numberErrorCode } from '@bingads-webui-campaign/hotel-common-upsert';

export const getDefaultBudget = (serverContext) => {
  const USDefaultBudget = (serverContext && serverContext.Permissions && serverContext.Permissions.IsDefaultBudgetExperimentationEnabled) ? 25 : 20;
  const budgetRange = serverContext && serverContext.BudgetRange;
  const accountCurrencyCode = getAccountCurrencyCode(serverContext);
  if (accountCurrencyCode === 'USD') {
    return decimal.fromFloatToString(USDefaultBudget, 2);
  }
  return decimal.fromFloatToString((budgetRange && budgetRange.DailyRange && budgetRange.DailyRange.FloorValue > 20) ? budgetRange.DailyRange.FloorValue : 20, 2);
};

export const getBudgetErrorMsg = ({ code, i18n, serverContext }) => {
  const budgetRange = serverContext && serverContext.BudgetRange;
  const accountCurrencyCode = getAccountCurrencyCode(serverContext);
  const min = (budgetRange && budgetRange.DailyRange && budgetRange.DailyRange.FloorValue) || 0.05;
  switch (code) {
    case numberErrorCode.RequiredField:
      return i18n.getString(_TL_('Enter a budget amount'));
    case numberErrorCode.InValidNumber:
      return i18n.getString(_TL_('Field requires numeric value'));
    case numberErrorCode.OutOfRange:
      return i18n.getString(_TL_('Your budget should be greater than {{currencyCode}} {{min}} and less than your daily maximum. The daily max. is your monthly budget averaged out over the number of days left in the month.'), { currencyCode: accountCurrencyCode, min: decimal.fromFloatToString(min) });
    default:
      return null;
  }
};

export const validateBudget = ({ value, serverContext }) => {
  const budgetRange = serverContext && serverContext.BudgetRange;
  const isValidNumber = typeof value === 'number' ? true : decimal.isValid(value);
  if (value == null || value === '') {
    return numberErrorCode.RequiredField;
  } else if (!isValidNumber) {
    return numberErrorCode.InValidNumber;
  } else if (budgetRange == null || budgetRange.DailyRange == null) {
    const number = decimal.fromLocalToFloat(value);
    if (number < 0.05) {
      return numberErrorCode.OutOfRange;
    }
  }
  const number = decimal.fromLocalToFloat(value);
  const min = budgetRange.DailyRange.FloorValue;
  const max = budgetRange.DailyRange.CeilingValue;
  if (number < min || number > max) {
    return numberErrorCode.OutOfRange;
  }

  return null;
};

export const isBudgetValid = ({ value, serverContext }) => validateBudget({ value, serverContext }) == null;
